import React, { useLayoutEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { Link, useNavigate } from "react-router-dom";

const VIEWPORT_MARGIN = 8;

export const CategoryFlyout = ({ categoria, onNavigate, toggleClassName = "" }) => {
  const [open, setOpen] = useState(false);
  const [pos, setPos] = useState({ top: 0, left: 0 });
  const wrapperRef = useRef(null);
  const menuRef = useRef(null);
  const navigate = useNavigate();

  // Se renderiza en document.body para no quedar recortado por el overflow del bloque de categorías.
  useLayoutEffect(() => {
    if (!open || !wrapperRef.current || !menuRef.current) return;
    const rect = wrapperRef.current.getBoundingClientRect();
    const menuWidth = menuRef.current.offsetWidth;
    const menuHeight = menuRef.current.offsetHeight;

    let left = rect.right;
    if (left + menuWidth > window.innerWidth - VIEWPORT_MARGIN) {
      left = Math.max(VIEWPORT_MARGIN, rect.left - menuWidth);
    }
    let top = rect.top;
    if (top + menuHeight > window.innerHeight - VIEWPORT_MARGIN) {
      top = Math.max(VIEWPORT_MARGIN, window.innerHeight - menuHeight - VIEWPORT_MARGIN);
    }
    setPos({ top, left });
  }, [open]);

  const handleNavigate = () => {
    setOpen(false);
    if (onNavigate) onNavigate();
  };

  return (
    <div
      ref={wrapperRef}
      className="category-flyout-wrapper"
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <button
        type="button"
        className={`btn btn-light dropdown-toggle w-100 text-start ${toggleClassName}`}
        onClick={() => {
          navigate(`/categorias/${categoria.Codigo}`);
          handleNavigate();
        }}
      >
        {categoria.Descripcion.toUpperCase()}
      </button>
      {open &&
        createPortal(
          <div
            ref={menuRef}
            className="dropdown-menu show category-flyout-menu"
            style={{ position: "fixed", top: pos.top, left: pos.left }}
          >
            {categoria.Hijos.map((sub) =>
              sub.Hijos && sub.Hijos.length > 0 ? (
                <CategoryFlyout
                  key={sub.Codigo}
                  categoria={sub}
                  onNavigate={handleNavigate}
                  toggleClassName="category-flyout-sub-toggle"
                />
              ) : (
                <Link
                  key={sub.Codigo}
                  to={`/categorias/${sub.Codigo}`}
                  className="dropdown-item"
                  onClick={handleNavigate}
                >
                  {sub.Descripcion.toUpperCase()}
                </Link>
              )
            )}
          </div>,
          document.body
        )}
    </div>
  );
};
